import { render, staticRenderFns } from "./SectionModel.vue?vue&type=template&id=6e5bb206&scoped=true"
import script from "./SectionModel.vue?vue&type=script&lang=js"
export * from "./SectionModel.vue?vue&type=script&lang=js"
import style0 from "./SectionModel.vue?vue&type=style&index=0&id=6e5bb206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5bb206",
  null
  
)

export default component.exports